import { useParty } from '../features/party-company-extended-detail/api/getParty';
import currencyList from '../../../common/src/constants/currencyList.json';

interface UseCurrency {
  currency: string;
  symbol: string;
}

const usePartyCurrency = (partyId?: string): UseCurrency => {
  const { data: party } = useParty(partyId);

  if (partyId) {
    return {
      currency: party?.preferred_currency || 'EUR',
      symbol: currencyList[party?.preferred_currency || 'EUR'],
    };
  }

  return {
    currency: 'EUR',
    symbol: currencyList.EUR,
  };
};

export default usePartyCurrency;
